import { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-yellow-500 via-primary to-yellow-500 py-3 px-4 shadow-lg shadow-primary/20">
        <p className="text-center text-sm md:text-base lg:text-lg font-bold text-black tracking-wide">
          EXCLUSIVO PARA EMPRESÁRIOS
        </p>
      </div>

      <div className="pt-12">
        {children}
      </div>

      <footer className="mt-auto bg-card border-t border-border">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <p className="text-sm text-muted-foreground">
              © 2026 Método Êxodo. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}